<template>
  <metainfo> </metainfo>
  <div class="share_btn">
    <p>分享給朋友:</p>

    <button>
      <ShareNetwork
        network="facebook"
        :url="data.url"
        :title="data.pageTitle"
        :description="data.pageTitle"
        :hashtags="
          data.pageTitle
            .replaceAll('「', '')
            .replaceAll('」', '')
            .replaceAll(' ', '')
            .replaceAll('，', '')
        "
      >
        <img src="../assets/images/facebook_icon.png" alt="face book icon" />
      </ShareNetwork>
    </button>
    <button @click="ShareLine()">
      <img src="../assets/images/line_icon.png" alt="line icon" />
    </button>
    <button>
      <ShareNetwork
        network="twitter"
        :url="data.url"
        :title="data.pageTitle"
        description=""
        :hashtags="
          data.pageTitle
            .replaceAll('「', '')
            .replaceAll('」', '')
            .replaceAll(' ', '')
            .replaceAll('，', '')
        "
      >
        <img src="../assets/images/twitter_icon.png" alt="line icon" />
      </ShareNetwork>
    </button>

    <!-- <button @click="shareArticle(FACEBOOK)">
      <img src="../assets/images/facebook_icon.png" alt="face book icon" />
    </button>
    <button @click="shareArticle(LINE)">
      <img src="../assets/images/line_icon.png" alt="line icon" />
    </button>
    <button @click="shareArticle(TWITTER)">
      <img src="../assets/images/twitter_icon.png" alt="twitter icon" />
    </button> -->
  </div>
</template>

<script>
import { shareArticle } from "@/util/article";
import { FACEBOOK, LINE, TWITTER } from "../util/article";
import { ref } from "vue";
import { useMeta } from "vue-meta";
import { ShareAltOutlined } from "@ant-design/icons-vue";
export default {
  name: "ShareBtns",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const pageTitle = ref(props.data.pageTitle);
    const pageurl = ref(props.data.url);
    function ShareLine() {
      const goalUrl = "https://social-plugins.line.me/lineit/share?url=" + pageurl.value;
      window.open(goalUrl, "_blank");
    }

    useMeta({
      meta: [
        {
          property: "og:title",
          content: pageTitle.value, // 设置 og:title 内容
        },
        {
          property: "og:description",
          content: pageTitle.value, // 设置 og:title 内容
        },
        {
          property: "og:url",
          content: pageurl.value, // 设置 og:title 内容
        },
        {
          property: "twitter:card",
          content: "summary", // 设置 og:title 内容
        },
        {
          property: "twitter:title",
          content: pageTitle.value, // 设置 og:title 内容
        },
        {
          property: "twitter:description",
          content: pageTitle.value, // 设置 og:title 内容
        },
        {
          property: "twitter:url",
          content: pageurl.value, // 设置 og:title 内容
        },
        // 其他 meta 标签可以在这里添加
      ],
    });

    return{ShareLine}
  },
};
</script>

<style lang="scss" scoped>
.share_btn {
  margin-bottom: 24px;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  p {
    font-size: $p;
  }

  button {
    margin: 4px;
    outline: none;
    border: none;

    &:hover {
      cursor: pointer;
    }

    img {
      width: 32px;
    }
  }
}
</style>
